import { Link } from 'react-router-dom';
import paymentMethods from '../assets/images/payment-methods.png';
import '../styles/Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-contact">
            <p>24/7 Support Team:</p>
            <p>Europe: +31 20 323 3138</p>
            <p>North America: +1 833 503 1203</p>
            <p>help@fit-dash.com</p>
            <p>Business ID: HE 443363</p>
          </div>

          <div className="footer-links">
            <p>Quick Links</p>
            <ul>
              <li><Link to="/plans" className="start-trial-btn">Start Trial</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/privacy-policy">Privacy & Data Policy</Link></li>
              <li><Link to="/refund-policy">Refund & Return Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
              <li><Link to="/payment-security">Payment & Security</Link></li>
            </ul>
          </div>

          <div className="footer-copyright">
            <p>Company Details</p>
            <p>Copyright © {new Date().getFullYear()} Fit Dash</p>
            <p>MOBILESPARK CREATIONS LTD, 53 - NEROUPOS BUSINESS CENTER, Flat/Office 203,3041, Limassol, Cyprus.</p>
            <p>Secure Payment Options</p>
            <img src={paymentMethods} alt="Payment Methods" className="payment-methods" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
